import { RequestType, Song, Artist } from '@/types'

export const Request = async ({
  url,
  method = 'GET',
  params,
}: RequestType): Promise<any> => {
  try {
    const response = await fetch(url, {
      method: method.toUpperCase(),
      mode: 'cors',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    })
    const result = await response.json()

    // console.log('Request', url, params, response, result)

    return result
  } catch (error) {
    console.error(error)

    return { head: -1, data: null, message: error }
  }
}

export const FetchSong = async ({ id, apiHost }): Promise<Song> => {
  const url = `${apiHost}/music/song/detail`
  const params = {
    songBaseInfoId: id,
  }
  const response = await Request({ url, method: 'POST', params })

  // console.log('FetchSong', url, params, response)

  return response?.songBaseInfo || null
}

export const FetchSimilars = async ({ id, apiHost }): Promise<Song[]> => {
  const url = `${apiHost}/music/song/similar`
  const params = { songBaseInfoId: id }
  const response = await Request({ url, method: 'POST', params })

  // console.log('FetchSimilars', url, params, response)

  return response || []
}

// 歌手列表
export const FetchArtists = async (apiHost, params): Promise<{ singerInfoList: Artist[], hasNext: boolean }> => {
  const url = `${apiHost}/music/singer/getMoreArtist`
  const response = await Request({ url, method: 'POST', params })

  // console.log('FetchArtists', url, params, response)

  return response || {}
}

// 歌手信息
export const FetchArtistInfo = async (apiHost, params): Promise<Artist> => {
  const url = `${apiHost}/music/singer/getArtistInfo`
  const response = await Request({ url, method: 'POST', params })

  // console.log('FetchArtistInfo', url, params, response)

  return response.singerInfo || null
}


// 歌手歌曲列表
export const FetchArtistSongs = async (apiHost, params): Promise<{ songList: Song[], hasNext: boolean }> => {
  const url = `${apiHost}/music/singer/getArtistSongs`
  const response = await Request({ url, method: 'POST', params })

  // console.log('FetchArtistSongs', url, params, response)

  return response || null
}


export const TrackReport= async ({ apiHost, params = {} }): Promise<any> => {
  const url = `${apiHost}/music/event/report`

  return await Request({ url, method: 'POST', params })
}
